<template>
  <div class="set-ema">
    <h1 class="title">账号安全设置</h1>
    <!-- <div class="register-head">
      <el-steps :active="active" class="phase" align-center>
        <el-step title="绑定手机号"></el-step>
        <el-step title="密保问题设置"></el-step>
        <el-step title="设置收件邮箱"></el-step>
      </el-steps>
    </div> -->
    <div style="width:550px;margin:0 auto;" class="change-loginPass">
      <div v-show="active === 1">
        <el-form :model="phoneCheck" ref="phoneCheck" :rules="phoneRules" label-width="100px" class="phoneCheck">
          <el-form-item label="手机号" prop="newPhone">
            <el-input v-model="phoneCheck.newPhone" :placeholder="userInfo.tbAccount.mobile.length > 0 ? userInfo.tbAccount.mobile : '请输入手机号码'"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="phoneVertifyCode" class="code">
            <el-input v-model="phoneCheck.phoneVertifyCode" placeholder="请输入短信验证码" style="width:250px;"></el-input>
            <el-button type="primary" @click="getSmsRecords">{{getSms_button}}</el-button>
          </el-form-item>
          <div style="text-align:center;">
            <el-button type="primary" style="width:100px;background:#1060ab;font-size:16px;margin-top:33px;" @click="doPhoneCheck">完成</el-button>
          </div>
        </el-form>
      </div>
      <div v-show="active === 2">
        <el-form :model="questionCheck" ref="questionCheck" :rules="questionRules" label-width="100px" class="questionCheck">
          <el-form-item label="问题" prop="saftyQuestion">
            <el-select v-model="questionCheck.saftyQuestion" :placeholder="userInfo.tbAccount.question.length > 0 ? userInfo.tbAccount.question : '请选择密保问题'">
              <el-option
                v-for="item in questionList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="答案" prop="answer">
            <el-input v-model="questionCheck.answer" :placeholder="userInfo.tbAccount.question.length > 0 ? userInfo.tbAccount.question : '请输入答案'"></el-input>
          </el-form-item>
          <div style="text-align:center;">
            <el-button type="primary" style="width:100px;background:#1060ab;font-size:16px;margin-top:33px;" @click="doQuestionCheck">完成</el-button>
          </div>
        </el-form>
      </div>
      <div v-show="active === 3">
        <el-form :model="emailCheck" ref="emailCheck" :rules="emailRules" label-width="100px" class="emailCheck">
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="emailCheck.email" placeholder="例如：123456@qq.com"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="emailVertifyCode" class="code">
            <el-input v-model="emailCheck.emailVertifyCode" style="width:275px;"></el-input>
            <el-button type="primary" @click="getEmailSms">{{email_button}}</el-button>
          </el-form-item>
          <div style="text-align:center;">
            <el-button type="primary" style="width:100px;background:#1060ab;font-size:16px;margin-top:33px;" @click="doEmailCheck">完成</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    const checkNewPhone = (rule, value, callback) => {
      if (/^((12|13|14|15|17|18|19)[0-9]{1}\d{8})$/.test(value)) {
        callback()
      } else {
        callback(new Error("手机格式错误"))
      }
    }
    const newSmsCheck = (rule, value, callback) => {
      this.$ajax
        .post(
          '/compute-oper-service/SmsRecords/isCheckCode',
          this.postData({
            checkCode: this.phoneCheck.phoneVertifyCode,
            mobile: this.phoneCheck.newPhone
          })
        )
        .then(res => {
          if (res.data === 0) {
            callback()
          } else {
            callback(new Error('验证码错误'))
          }
        })
    }
    const checkEmail = (rule, value, callback) => {
      var myReg = /^[a-zA-Z0-9_-]+@([a-zA-Z0-9]+\.)+(com|cn|net|org)$/;
      if (value.length > 30) {
        callback(new Error("邮箱长度过长"));
      } else if (myReg.test(value)) {
        callback();
      } else {
        callback(new Error("邮箱格式不正确"));
      }
    }
    const newEmailSms = (rule, value, callback) => {
      this.$ajax
        .post(
          '/compute-oper-service/SmsRecords/checkEmailCode',
          this.postData({
            checkCode: this.emailCheck.emailVertifyCode,
            userId: sessionStorage.userUuid
          })
        )
        .then(res => {
          if (res.data === 0) {
            callback()
          } else {
            callback(new Error('验证码错误'))
          }
        })
    }
    return {
      time: 0,
      time2: 0,
      active: 3,
      getSms_button: '获取短信验证码',
      email_button: '发送验证码',
      phoneCheck: {
        newPhone: '',
        phoneVertifyCode: ''
      },
      questionCheck: {
        saftyQuestion: '',
        answer: ''
      },
      emailCheck: {
        email: '',
        emailVertifyCode: ''
      },
      phoneRules: {
        newPhone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: checkNewPhone, trigger: "blur" }
        ],
        phoneVertifyCode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
          { validator: newSmsCheck, trigger: "submit" }
        ]
      },
      questionRules: {
        saftyQuestion: {required: true, message: "请选择密保问题", trigger: "blur"},
        answer: [
          {required: true, message: "请输入答案", trigger: "blur"},
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ]
      },
      emailRules: {
        email: [
          { required: true, message: "请输入电子邮箱", trigger: "blur" },
          { validator: checkEmail, trigger: "blur" }
        ],
        emailVertifyCode: [
          { required: true, message: "请输入邮箱验证码", trigger: "blur" },
          { validator: newEmailSms, trigger: "submit" }
        ]
      },
      questionList: [],
      userInfo: []
    }
  },
  created () {
    if (sessionStorage.whichWay !== 'email') {
      this.$router.push('/trainClass/personalCenter/accountInfo/accountSafty')
    } else {
      this.$ajax
        .post(
          "/comuser-service/Account/seeAccount",
          this.postData({
            id: sessionStorage.userUuid
          })
        )
        .then(res => {
          this.userInfo = res.data
        })
      this.getQuestion()
    }
  },
  mounted () {
  },
  methods: {
    getQuestion () {
      this.$ajax
        .post(
          '/auth-config-service/dict/getSecurityQuestion'
        )
        .then(res => {
          if ((res.code === '200')) {
            for (let i = 0; i < res.data.length; i++) {
              this.questionList.push({
                value: res.data[i].dictValue,
                label: res.data[i].dictValue
              })
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    doPhoneCheck () {
      this.$refs['phoneCheck'].validate(valid => {
        if (valid) {
          this.$ajax
            .post(
              '/comuser-service/Account/updateMobile',
              this.postData({
                id: sessionStorage.userUuid,
                mobile: this.phoneCheck.newPhone
              })
            )
            .then(res => {
              if ((res.code === '200')) {
                this.$message({
                  message: "手机号保存成功",
                  type: "success"
                })
                setTimeout(() => {
                  this.$router.push('/trainClass/personalCenter/accountInfo/accountSafty')
                }, 1000)
              } else {
                this.$message.error(res.message)
              }
            })
        }
      })
    },
    doQuestionCheck () {
      this.$refs['questionCheck'].validate(valid => {
        if (valid) {
          let tbAccount = {
            id: sessionStorage.userUuid,
            question: this.questionCheck.saftyQuestion,
            answer: this.questionCheck.answer
          }
          this.$ajax
            .post(
              '/comuser-service/Account/updateUser',
              this.postData({
                tbAccount1: JSON.stringify(tbAccount)
              })
            )
            .then(res => {
              if ((res.code === '200')) {
                this.$message({
                  message: "密保问题保存成功",
                  type: "success"
                })
                setTimeout(() => {
                  this.$router.push('/trainClass/personalCenter/accountInfo/accountSafty')
                }, 1000)
              } else {
                this.$message.error(res.message)
              }
            })
        }
      })
    },
    doEmailCheck () {
      this.$refs['emailCheck'].validate(valid => {
        if (valid) {
          let tbAccount = {
            id: sessionStorage.userUuid,
            emailAddress: this.emailCheck.email
          }
          this.$ajax
            .post(
              '/comuser-service/Account/updateUser',
              this.postData({
                tbAccount1: JSON.stringify(tbAccount)
              })
            )
            .then(res => {
              if ((res.code === '200')) {
                this.$message({
                  message: "邮箱保存成功",
                  type: "success"
                })
                setTimeout(() => {
                  sessionStorage.hasChecked = 'info'
                  this.$router.push('/trainClass/personalCenter/accountInfo/accountSafty')
                }, 2000)
              } else {
                this.$message.error(res.message)
              }
            })
        }
      })
    },
    getSmsRecords () {
      this.$refs['phoneCheck'].validateField("newPhone", valid => {
        if (valid === "") {
          if (this.time === 0) {
            this.time = 60
            this.timer()
            this.$ajax
              .post(
                '/compute-oper-service/SmsRecords/addCheckCodexbkgj',
                this.postData({
                  codeType: 1,
                  phoneNumber: this.phoneCheck.newPhone
                })
              )
              .then(res => {
                if (res.code === '200') {
                  this.$message({
                    type: 'success',
                    message: '验证码发送成功'
                  })
                } else {
                  this.$message.error(res.message)
                }
              })
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getEmailSms () {
      this.$refs['emailCheck'].validateField("email", valid => {
        if (valid === "") {
          if (this.time2 === 0) {
            this.time2 = 60
            this.timer2()
            this.$ajax
              .post(
                '/compute-oper-service/SmsRecords/sendEmail',
                this.postData({
                  userId: sessionStorage.userUuid,
                  type: '3',
                  email: this.emailCheck.email
                })
              )
              .then(res => {
                if (res.code === '200') {
                  this.$message({
                    type: 'success',
                    message: '验证码发送成功'
                  })
                } else {
                  this.$message.error('验证码发送失败')
                }
              })
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });

    },
    timer () {
      if (this.time > 0) {
        this.time--
        this.getSms_button = this.time + 's后重新获取'
        var timer = setTimeout(this.timer, 1000)
      } else if (this.time === 0) {
        this.getSms_button = '获取短信验证码'
        clearTimeout(timer)
      }
    },
    timer2 () {
      if (this.time2 > 0) {
        this.time2--
        this.email_button = this.time2 + 's后重新获取'
        var timer = setTimeout(this.timer2, 1000)
      } else if (this.time2 === 0) {
        this.email_button = '获取验证码'
        clearTimeout(timer)
      }
    }
  }
}
</script>
<style lang="scss">
.set-ema {
  width: 1020px;
  margin: 0 auto;
  background: rgb(255, 255, 255);
  .title {
    font-weight: normal;
    font-size: 24px;
    margin: 30px 40px 90px 40px;
    color: #333333;
  }
  .register-head {
    margin: 0 40px;
    padding-top: 50px;
    padding-bottom: 25px;
    border-top: 1px #eeeeee solid;
    .el-step__icon {
      background-color: #dcdcdc;
      height: 30px;
      width: 30px;
      color: #ffffff;
    }
    .el-step__icon.is-text {
      border: none;
    }
    .phase {
      margin: 0 auto;
      margin-bottom: 45px;
      width: 550px;
      text-align: left;
      color: #999999;
    }
    .el-step__title.is-finish,
    .el-step__title.is-process,
    .el-step__title.is-wait,
    .el-step__head.is-finish {
      color: #999999;
      border-color: #dcdcdc;
      font-weight: normal;
    }
    .el-step__line {
      background-color: #dcdcdc;
    }
    .el-step__head.is-finish .el-step__icon {
      background-color: #0a6cb1;
    }
  }
  .phoneCheck {
    .el-form-item__label {
      font-size: 16px;
      color: #333333;
    }
    .el-input {
      width: 400px;
    }
    .code {
        .el-button--primary {
          background-color: #eeeeee;
          border-color: #d2d2d2;
          color: #666666;
          margin-left: 10px;
        }
      }
  }
  .questionCheck {
    margin-bottom:33px;
    .el-form-item__label {
      font-size: 16px;
      color: #333333;
    }
    .el-input {
      width: 400px;
    }
  }
  .emailCheck {
    .el-form-item__label {
      font-size: 16px;
      color: #333333;
    }
    .el-input {
      width: 400px;
    }
    .code {
        .el-button--primary {
          background-color: #eeeeee;
          border-color: #d2d2d2;
          color: #666666;
          margin-left: 10px;
          margin-bottom: 33px;
        }
      }
  }
}
</style>





// WEBPACK FOOTER //
// src/views/trainClass/personalCenter/accountInfo/setEma.vue